<template>

  <div id="loginbg">  ·
    <div id="ding">
      <div class="title"id="wenzi">
        自提系统
      </div>
      <div class="title"id="zhanghao">
        账号
      </div>
      <div class="title"id="tuichu"@click="logout">
        【退出】
      </div>
      <div class="title"id="yuyue" @click="tiaozhuanyuyue">
        预约
      </div>
      <div class="title"id="basic" @click="shouye">
        首页
      </div>
    </div>
    <div style="position: absolute;background-color: white;top: 71px;width: 80%;left: 140px;height: 60px;">
      <el-button id="xiugai "type="primary" style="position: absolute;left: 20px;top: 16px;" size="mini"@click="handleEdit()">修改</el-button>
      <el-button id="quxiao" type="danger" style="position: absolute;left: 80px;top: 16px;" size="mini"@click="handleDelete()">删除</el-button>
      <!--action="http://localhost:8881/excel/importLogistics"-->
      <!--<el-col :span="12" >
        <el-upload
                class="upload-demo"
                action="/api/excel/importOrderProduct"
                :limit="1"
                :headers="headers"
                :on-exceed="handleExceed"
                :before-upload="handleBeforeUpload"
                :multiple="false"
                :on-success="handlesuccess"
                :on-error="handleerror"
        >
          <el-button id="daoRu" size="mini" type="primary"style="margin-left: 150px;margin-top: 16px;" >批量导入</el-button>
        </el-upload>
      </el-col>-->
      <el-button id="daochu" type="primary"  style="position: absolute;left: 150px;top: 16px;" size="mini"@click="handleadd()">录入</el-button>
      <el-input v-model="gaojichaxuntemp" style="position: absolute;left: 300px;width: 220px;top: 11px" placeholder="商品名称" clearable>
      </el-input>
      <!--<img src="../../assets/Search.png"style="position: absolute;left: 1030px;top: 18px;width: 70px;" @click="gaojichaxun()">-->
      <el-button type="primary"size="mini" style="position: absolute;left: 530px;top: 17px;border-radius:4px;"icon="el-icon-search"@click="gaojichaxun()">搜索</el-button>
    </div>

    <!-- <el-divider id="fengexian"></el-divider>-->
    <el-table :data="pageData.rows" v-loading="listLoading"
              size=mini style="width: 80%; left: 140px;height:580px;top: 74px;"@selection-change="selsChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column prop="productId" label="productId"  width="40"v-if="false" >
      </el-table-column>
      <el-table-column prop="id" label="id"  width="40"v-if="false" >
      </el-table-column>
      <el-table-column prop="numberId" label="numberId"  width="40"v-if="false" >
      </el-table-column>
      <el-table-column prop="name" label="商品名称" width="250" sortable>
      </el-table-column>
      <el-table-column prop="spec" label="商品规格" width="320" sortable>
      </el-table-column>
      <el-table-column prop="number" label="商品数量" width="220" sortable>
      </el-table-column>
      <!--<el-table-column prop="card" label="提货卡卡号" width="220" sortable>
      </el-table-column>-->
      <el-table-column prop="url" label="商品图片" width="250" sortable>
        <template scope="scope">
          <el-popover placement="right" title="" trigger="hover">
            <img :src="scope.row.url" style="height: 400px;width: 500px">
            <img slot="reference" :src="scope.row.url" :alt="scope.row.url" style="max-height: 50px;max-width: 130px">
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            @current-change="handleCurrentChange"
            :current-page="query.page"
            :page-size=pagesize
            :total="pageData.total"
            style="position: absolute;margin-left: 530px;margin-top: 20px;">
    </el-pagination>

    <el-dialog :visible.sync="upVisible" :close-on-click-modal="false" style="position: absolute;width: 1200px;left: 180px" :before-close="closeDialog">
      <el-form :model="resform5"  label-width="100px" ref="resform5" id="resform5">
        <!-- <div id="errorimg">
           <img id="error" src="../../assets/error.png" @click="tuichu()">
         </div>-->

        <el-form-item prop="name" label="数量id:"v-show="showNumberId">
          <el-input type="text" v-model="resform5.numberId"></el-input>
        </el-form-item>
        <el-form-item prop="name" label="商品名称:">
          <el-input type="text" v-model="resform5.name" auto-complete="off" placeholder="请输入商品名称"clearable></el-input>
        </el-form-item>
        <el-form-item prop="spec" label="商品规格:">
          <el-input type="text" v-model="resform5.spec" auto-complete="off" placeholder="请输入商品规格"clearable></el-input>
        </el-form-item>
        <el-form-item prop="number" label="商品数量:">
          <el-input type="text" v-model="resform5.number" auto-complete="off" placeholder="请输入商品数量"clearable></el-input>
        </el-form-item>
        <el-form-item prop="url" label="商品图片:">
          <!--
            elementui 提供的文件上传组件 el-upload
            action：上传文件的接口路径  注意是post
            :on-success action调用后端上传文件成功之后，触发函数

            :on-preview 缩略图
            :on-remove 点击删除按钮的时候，触发方法

            :file-list 当前上传的所有文件
         -->
          <el-upload
                  ref="upload"
                  :limit="1"
                  class="upload-demo"
                  action="/api/oss/addPicture"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  :before-upload="handleBeforeUpload"
                  :on-exceed="handleExceed"
                  :file-list="fileList"
                  list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传1张jpg/png文件，且上传的图片名不能重复，大小不超过5M</div>
          </el-upload>
        </el-form-item>
        <el-button type="primary"  style="width: 100%;margin-top: 40px;" @click="reservationUpdate('resform5')" :loading="resLoading">确定</el-button>
      </el-form>
    </el-dialog>
    <!--=========================================================-->

    <el-dialog id="form6" :visible.sync="addVisible" :close-on-click-modal="false" style="position: absolute;width: 1200px;left: 180px" :before-close="closeDialog1">
      <el-form :model="resform6"  label-width="100px" ref="resform6" :rules="formRules" >
        <!--<div id="errorimg1">
          <img id="error1" src="../../assets/error.png" @click="tuichu()">
        </div>-->
        <el-form-item prop="name" label="商品名称:">
          <el-input type="text" v-model="resform6.name" auto-complete="off" placeholder="请输入商品名称"clearable></el-input>
        </el-form-item>
        <el-form-item prop="spec" label="商品规格:">
          <el-input type="text" v-model="resform6.spec" auto-complete="off" placeholder="请输入商品规格"clearable></el-input>
        </el-form-item>
        <el-form-item prop="number" label="商品数量:">
          <el-input type="text" v-model="resform6.number" auto-complete="off" placeholder="请输入商品数量"clearable></el-input>
        </el-form-item>
        <!--<el-form-item label="提货卡卡号:" prop="card">
          <el-input v-model="resform6.card" auto-complete="off" placeholder="请输入提货卡卡号"></el-input>
        </el-form-item>-->
        <el-form-item prop="url" label="商品图片:">
          <!--
            elementui 提供的文件上传组件 el-upload
            action：上传文件的接口路径  注意是post
            :on-success action调用后端上传文件成功之后，触发函数

            :on-preview 缩略图
            :on-remove 点击删除按钮的时候，触发方法

            :file-list 当前上传的所有文件
         -->
          <el-upload
                  ref="upload"
                  :limit="1"
                  class="upload-demo"
                  action="/api/oss/addPicture"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  :before-upload="handleBeforeUpload"
                  :on-exceed="handleExceed"
                  :file-list="fileList"
                  list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传1张jpg/png文件，且上传的图片名不能重复，大小不超过5M</div>
          </el-upload>
        </el-form-item>
        <el-button type="primary"  style="width: 100%;margin-top: 40px;" @click="reservationAdd('resform6')" :loading="resLoading">确定</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  //import NProgress from 'nprogress'
  export default {
    data() {
      return {
        showNumberId:false,
        fileList: [],
        pagesize:5,
        headers:{
          "U-TOKEN":localStorage.getItem("U-TOKEN")
        },
        FormData:{},
        sels: [],
        gaojichaxuntemp:'',
        checked1:false,
        checkedres:[],
        resform5:{
          id:null,
          numberId:null,
          name:"",
          spec:"",
          number:"",
          url:"",
        },
        resform6:{
          //card:"",
          name:"",
          spec:"",
          number:"",
          url:""
        },
        checkedres1:{
          all:"全选",
          nores:'未受理',
          alrres:'已受理',
          alrdlv:'已发货'
        },
        province:"",
        city :"",
        area :"",
        listLoading: false,
        selectVisible: false,//查看界面是否显示
        selectLogisticsVisible: false,
        addVisible: false,
        upVisible: false,
        selectdata:{
          detailAddress:"",
          logisticsAddress:"",
          logisticsDate:null,
          deliverTime:null,
          userName: "",
          number: "",
          phone: "",
          card: "",
          address: "",
          userDetailAddress: null,
          orderProduct: "",
          spec: "",
          numberProduct: ""
        },
        selectLogisticsData:[
          {
            time:'',
            status:''
          }
        ],
        resLoading:false,
        logining: false,
        checked: false,
        pageData: {
          total: 0,
          rows: []
        },
        query: {
          page: 1,
          name:""
        },
        formRules: {
          /*card: [
            { required: true, message: '请输入提货卡卡号', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],*/
          name: [
            { required: true, message: '请输入商品名称', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          spec: [
            { required: true, message: '请输入商品规格', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          number: [
            { required: true, message: '请输入商品数量', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          url: [
            { required: true, message: '请输入商品数量', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],

          fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
        },
      };
    },
    methods: {
      tuichu() {
        document.getElementById("products5").style.display = "none";
        document.getElementById("products2").style.display = "none";
      },
      //显示编辑界面
      handleEdit: function () {
        var ids = this.sels.map(item => item.id);
        //console.log(ids)
        if (ids.length == 0 || ids.length > 1) {
          this.$message({
            message: "请选择一条信息进行修改",
            type: 'error'
          });
          return;
        }
        this.upVisible =true
        //document.getElementById("products5").style.display = "";
        //回显
        this.resform5.id = this.sels[0].id
        this.resform5.name = this.sels[0].name
        this.resform5.spec = this.sels[0].spec
        this.resform5.number = this.sels[0].number
        this.resform5.url = this.sels[0].url
        this.resform5.numberId = this.sels[0].numberId
        this.fileList.push({
          url:this.resform5.url
        })

      },
      //显示查询页面
      handleSelect1: function (index, row) {
        this.selectVisible = true;
        this.selectdata = Object.assign({}, row);
        this.handleClick(index, row)
      },
      /* handleCurrentChange(page) {
         if (this.gaojichaxuntemp.length === 0){
           this.query.page = page
           this.getpagelist();
         }else {
           this.query.page = page
           this.gaojichaxun();
         }
       },*/
      handleCurrentChange(page) {
        this.query.page = page
        this.getpagelist();
        //this.gaojichaxun();
      },
      //获取分页列表
      getpagelist() {
        this.listLoading = true;
        this.$http.post("/productBase/pagelist", this.query).then(res => {
          if (res.data.success) {
            this.pageData = res.data.data
            this.listLoading = false;
          }else {
            this.$message.error(res.data.message);
          }
        }).catch(error => {
          this.listLoading = false;
          this.$message({message: "数据加载失败[" + error.message + "]", type: 'error'});
        })
      },
      handleClick(index, row) {
        let param = {
          phone: row.phone,
          number: row.logisticsNumber
        }
        this.$http.post("/reservationOrder/selectLogistics", param).then(res => {
          if (res.data.success) {
            var datas = res.data.data;
            this.selectDeliverDetail(param, datas);
          }else {
            this.$message.error(res.data.message);
          }
        }).catch(error => {
          this.$message({message: "数据加载失败[" + error.message + "]", type: 'error'});
        })
      },
      selectDeliverDetail(param, datas) {
        let param1 = {
          number: param.number
        }
        this.$http.post("/reservationOrder/selectDeliverDetail", param1).then(res => {
          if (res.data.success) {
            this.selectdata = res.data.data;
            this.selectdata.detailAddress = datas.detailAddress
            this.selectdata.logisticsAddress = datas.logisticsAddress
            this.selectdata.logisticsDate = datas.logisticsDate
          }else {
            this.$message.error(res.data.message);
          }
        }).catch(error => {
          this.$message({message: "数据加载失败[" + error.message + "]", type: 'error'});
        })
      },
      reservationUpdate(resform5) {
        this.$refs.resform5.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.resLoading = true;
              let para = Object.assign({}, this.resform5);

              console.log(this.resform5)
              this.$http.post("/productBase/updateProduct", para).then(res => {
                this.resLoading = false;
                if (res.data.success) {
                  this.$message({
                    message: '修改成功',
                    type: 'success'
                  });
                  this.upVisible = false;
                  //this.getpagelist();
                  window.setTimeout(function () {
                    window.location.reload();
                  },2000)
                } else {
                  this.$message.error(res.data.message);
                  this.upVisible = false;
                  //this.getpagelist();
                  window.setTimeout(function () {
                    window.location.reload();
                  },2000)
                }
              })
            }).catch(error => {
              this.$message({
                message: '修改失败',
                type: 'error'
              });
              this.resLoading = false;
              return;
            });
          }
        });
      },
      handleDelete: function () {
        var ids = this.sels.map(item => item.id);
        var numberId = this.sels.map(item => item.numberId);
        var productId = this.sels.map(item => item.productId);
        var ids1 = ids.toString();
        var numberId1 = numberId.toString();
        var productId1 = productId.toString();
        let param = {
          id: ids1,
          numberId: numberId1,
          productId: productId1
        }
        if (ids.length == 0 || ids.length > 1) {
          this.$message({
            message: "请选择一条信息进行删除",
            type: 'error'
          });
          return;
        }
        this.$confirm('确认删除吗?', '提示', {
          type: 'warning'
        }).then(() => {
          this.$http.post("/productBase/deleteProduct" , param).then(result => {
            result = result.data;
            if (result.success) {
              this.$message({
                message: result.message,
                type: 'success'
              });
              this.query.page = 1;
              this.getpagelist();
            } else {
              this.$message({
                message: result.message,
                type: 'error'
              });
              this.query.page = 1;
              this.getpagelist();
            }
          }).catch(result => {
            this.$message({
              message: '系统繁忙，稍后重试！！',
              type: 'error'
            });
          })
        }).catch(() => {

        });
      },
      gaojichaxun() {
        //console.log(this.query)
        if (this.gaojichaxuntemp.length > 0) {
          this.query.name = this.gaojichaxuntemp
          this.listLoading = true;
          this.$http.post("/productBase/pagelist", this.query).then(res => {
            if (res.data.success) {
              this.pageData = res.data.data
              this.listLoading = false;
              this.query.name = ''
            } else {
              this.$message({
                message: res.data.message,
                type: 'error'
              });
              this.listLoading = false;
            }
          }).catch(error => {
            this.listLoading = false;
            this.$message({message: "数据加载失败[" + error.message + "]", type: 'error'});
          });
        } else if(this.gaojichaxuntemp.length === 0){
          this.listLoading = true;
          this.getpagelist();
        }

      },
      selsChange: function (sels) {
        this.sels = sels;
      },
      /**
       * 导出
       */
      exportExcel() {
        var ids = this.sels.map(item => item.id);
        if (ids < 1) {
          this.$message({
            message: "请至少选择一条未受理的数据进行导出",
            type: 'error'
          });
          return;
        }
        //console.log(ids)
        location.href = "http://localhost:8881/excel/exportPartRes" + "?ids=" + ids
      },
      handleBeforeUpload(file) {
        const uploadLimit = 5
        const uploadTypes = ['jpg', 'png']
        const filetype = file.name.replace(/.+\./, '')
        const isRightSize = (file.size || 0) / 1024 / 1024 < uploadLimit
        //console.log(isRightSize)
        if (!isRightSize) {
          this.$message.error('文件大小超过 ' + uploadLimit + 'MB')
          return false
        }
        //console.log(filetype.toLowerCase())
        if (uploadTypes.indexOf(filetype.toLowerCase()) === -1) {
          this.$message.warning({
            message: '请上传后缀名为jpg或png的附件'
          })
          return false
        }
        return true
      },
      handleExceed(files, fileList) {
        this.$message.warning({
          message: '超出上传限制'
        })
      },
      handlesuccess(){
        this.$message({
          message: '导入成功',
          type: 'success'
        });
        this.getpagelist();
      },
      handleerror(){
        this.$message({
          message: '导入失败，请仔细核对文件',
          type: 'error'
        });
      },
      shouye(){
        this.$router.push({ path: '/serviceReservationOrder' });
      },
      tiaozhuanyuyue(){
        //this.$router.push({ path: '/cardLogin' });
        location.href = "https://ahyfyx.com/#/cardLogin"
      },
      handleadd(){
        //document.getElementById("products2").style.display = "";
        this.addVisible = true;
      },
      closeDialog(done){
        this.$confirm('确认关闭？')
                .then(_ => {
                  done();
                  location.reload();
                })
                .catch(_ => { });
      },
      closeDialog1(done){
        this.$confirm('确认关闭？')
                .then(_ => {
                  this.deletePicture(this.resform6.url);
                  done();
                  location.reload();
                })
                .catch(_ => { });
      },
      addDomain() {
        this.resform6.productList.push({
          /* key:Date.now(),
           key2:Date.now()+1,
           key3:Date.now()+2*/
        });
      },
      addDomain1() {
        this.resform5.productList.push({
                }
                //this.resform5.productList[1].name = ""
        );
      },
      removeOrderProduct(item) {
        var index = this.resform6.productList.indexOf(item)
        if (index !== -1) {
          this.resform6.productList.splice(index, 1)
        }
      },
      removeOrderProduct1(item) {
        var index = this.resform5.productList.indexOf(item)
        if (index !== -1) {
          this.resform5.productList.splice(index, 1)
        }
      },
      reservationAdd(resform6){
        this.$refs[resform6].validate((valid) => {
          if (valid) {
            //console.log(this.resform6)
            this.$confirm('确认添加吗?', '提示', {}).then(() => {
              this.$http.post("/productBase/saveProduct", this.resform6).then(result => {
                result = result.data;
                if (result.success) {
                  this.$message({
                    message: '添加成功',
                    type: 'success',
                  });
                  this.$refs.resform6.resetFields();
                  this.addVisible = false;
                  //this.getpagelist();
                  window.setTimeout(function () {
                    window.location.reload();
                  },2000)
                } else {
                  this.$message({
                    message: result.message,
                    type: 'error'
                  });
                  this.$refs.resform6.resetFields();
                  //重置图片
                  this.$refs.upload.clearFiles();
                  this.addVisible = false;
                  //this.getpagelist();
                  window.setTimeout(function () {
                    window.location.reload();
                  },2000)
                }
              }).catch(result => {
                this.$message({
                  message: '系统繁忙，稍后重试！！',
                  type: 'error'
                });
                this.$refs.resform6.resetFields();
                this.addVisible = false;
              })
            }).catch(() => {

            });
          }
        });
      },
      //退出登录
      logout: function () {
        this.$confirm('确认退出吗?', '提示', {
          //type: 'warning'
        }).then(() => {
          localStorage.removeItem('loginInfo');
          localStorage.removeItem('U-TOKEN');
          localStorage.removeItem('permissions');
          //====================退出的时候需要刷新一下本地的路由缓存
          //location.reload();
          //================
          this.$router.push({ path: '/login' });
        }).catch(() => {
        });
      },
      forceUpdate() {
        this.$forceUpdate()
      },
      //图片预览
      handlePreview(file) {
        //console.log(file);
      },
      deletePicture(url){
        //console.log(url)
        if (url == null || url == ''){
          return
        }else {
          var name = url.substring(32)
          //console.log(name)
          let fileName ={
            name:name
          }
          this.$http.post("/oss/deletePicture",fileName)
                  .then(res=>{
                    if(res.data.success){
                      /*this.$message({
                        message: '删除成功!',
                        type: 'success'
                      });*/
                    }else{
                      /*this.$message({
                        message: '删除失败!',
                        type: 'error'
                      });*/
                    }
                  })
        }
      },
      //文件删除
      handleRemove(file, fileList,response) {
        if (file.url != null){
          //console.log(file.url)
          var name = file.url.substring(32)
          let fileName ={
            name:name
          }
          this.$http.post("/oss/deletePicture",fileName)
                  .then(res=>{
                    if(res.data.success){
                      /*this.$message({
                        message: '删除成功!',
                        type: 'success'
                      });*/
                    }else{
                      /*this.$message({
                        message: '删除失败!',
                        type: 'error'
                      });*/
                    }
                  })
        }else {
          let fileName ={
            name:file.name
          }
          //console.log(file.name)
          // http://localhost:8080/fastDfs?path=sadfasfads
          this.$http.post("/oss/deletePicture",fileName)
                  .then(res=>{
                    if(res.data.success){
                      /*this.$message({
                        message: '删除成功!',
                        type: 'success'
                      });*/
                    }else{
                      /*this.$message({
                        message: '删除失败!',
                        type: 'error'
                      });*/
                    }
                  })
        }
      },
      //文件上传成功回调
      handleSuccess(response, file, fileList){
        //console.log(response)
        this.resform6.url = response.data;
        this.resform5.url = response.data;
      },
    },
    mounted() {
      this.getpagelist();
    }
  }

</script>

<style lang="scss" scoped>
  #products2{
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 100px auto;
    width: 350px;
    padding: 37px 90px 35px 15px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }
  #products5{
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 30px auto;
    width: 550px;
    padding: 40px 50px 35px 45px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }
  #loginbg{
    background-image: url('../../assets/login.png');
    background-position: center;
    background-size:  100% 100%;
    background-repeat: no-repeat;
    height: 100%;
    //background-color: black;
  }
  #ding{
    background-color: #303133;
    height: 58px;
    margin-top: -18px;
  }
  #wenzi{
    position: absolute;
    margin-top: 18px;
    font-size: large;
    color: white;
    left: 100px;
    font-family: "PingFang SC";
    font-weight: 600;
  }
  #zhanghao{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 1100px;
    font-family: "PingFang SC";
    font-weight: 400;
  }
  #tuichu{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 1180px;
    font-family: "PingFang SC";
    font-weight: 400;
    cursor:pointer
  }
  #tuichu:hover {
    color: #c1e9f8;
  }
  #yuyue{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 250px;
    font-family: "PingFang SC";
    font-weight: 400;
    cursor:pointer
  }
  #yuyue:hover {
    color: #c1e9f8;
  }
  #errorimg{
    position: absolute;
    left: 610px;
    top: 15px;
  }
  #errorimg1{
    position: absolute;
    left: 380px;
    top: 15px;
  }
  #fengexian{
    position: absolute;
    top: 102px;
    width: 85%;
    left: 110px;
  }
  #basic{
    position: absolute;
    margin-top: 20px;
    font-size: 16px;
    color: white;
    left: 350px;
    font-family: "PingFang SC";
    font-weight: 400;
    cursor:pointer
  }
  #basic:hover {
    color: #c1e9f8;
  }
</style>



// WEBPACK FOOTER //
// ServiceProduct.vue?f9681110